import { TFunction } from "react-i18next";
import * as yup from "yup";
import { LoginFormValues } from "./interfaces";

export const initialValues: LoginFormValues = {
  email: "",
  password: "",
};

export const getValidationSchema = (
  t: TFunction
): yup.SchemaOf<LoginFormValues> =>
  yup.object().shape({
    email: yup
      .string()
      .email(t("7894") /* O campo deverá ser válido */)
      .required(t("7893") /* O campo deverá ser preenchido */),
    password: yup
      .string()
      .required(t("7893") /* O campo deverá ser preenchido */),
  });
